import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-base-carousel-indicators"
}
const _hoisted_2 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($options.items.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.items, (item, index) => {
          return (_openBlock(), _createElementBlock("a", {
            key: item.id,
            href: "#",
            class: _normalizeClass(['gfu-base-carousel-indicators__indicator', { 'is-active': item.isActive}]),
            onClick: _withModifiers($event => ($options.onClick(index)), ["prevent"])
          }, null, 10 /* CLASS, PROPS */, _hoisted_2))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}